
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCO_S0bCM3VkQnEBdTWwjaygqJpZd7kHBc",
  authDomain: "mapa-onpsc.firebaseapp.com",
  projectId: "mapa-onpsc",
  storageBucket: "mapa-onpsc.appspot.com",
  messagingSenderId: "342933695545",
  appId: "1:342933695545:web:e9cbb58771e865062171e8",
  measurementId: "G-N71Y0R44YC"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

var db = firebase.firestore();


var app = new Vue({
  el: "#vue_app",
  data() {
    return {
      provincias: ["Buenos Aires", "Capital Federal", "Catamarca", "Chaco", "Chubut", "Córdoba", "Corrientes", "Entre Ríos", "Formosa", "Jujuy", "La Pampa", "La Rioja", "Mendoza", "Misiones", "Neuquén", "Río Negro", "Salta", "San Juan", "San Luis", "Santa Cruz", "Santa Fe", "Santiago del Estero", "Tierra del Fuego", "Tucumán"],

      formCarga: {
        tipo: "Seleccione el tipo de lugar",
        nombre: "",
        ubicacion: {
          direccion: "",
          ciudad: "",
          provincia: "Seleccione la provincia",
          coordenadas: {
            lat: null,
            lng: null
          }
        },
        telefono: "",
        email: "",
        link_prin: "",
        link_int: "",
        descripcion: "",
        comentarios: "",

      },
      edicion_ubicacion_manual: {
        active: false,
        lat: 0,
        lng: 0
      },
      checkbox_terminos: false,
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
    resetFormCarga: function () {
      app.formCarga = {
        tipo: "Seleccione el tipo de lugar",
        nombre: "",
        ubicacion: {
          direccion: "",
          ciudad: "",
          provincia: "Seleccione la provincia",
          coordenadas: {
            lat: null,
            lng: null
          }
        },
        telefono: "",
        email: "",
        link_prin: "",
        link_int: "",
        descripcion: "",
        comentarios: "",

      }
    },
    validarUbicacion: function () {
      ubicacion = app.formCarga.ubicacion

      if (ubicacion.ciudad != "" && ubicacion.provincia != "Seleccione la provincia") {
        direccion_compuesta = ubicacion.direccion + ', ' + ubicacion.ciudad + ', ' + ubicacion.provincia

        document.querySelector("#map").innerHTML =
          `<iframe class="w-100" height="300" style="border:0" allowfullscreen src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAO46ka6UUQlpdbobTcNvYa4mgTGAAgY5Q&q=${direccion_compuesta}">
                        </iframe>`

        contenedor_mapa_ubicacion = document.querySelector("#contenedor_mapa_ubicacion")

        var mapa_bs = new bootstrap.Collapse(contenedor_mapa_ubicacion,{
          toggle: false
        })

        mapa_bs.show()
      }

    },

    ubicacionCorrecta: function () {
      ubicacion = app.formCarga.ubicacion
      if (app.edicion_ubicacion_manual.active) {
        direccion_compuesta = app.edicion_ubicacion_manual.lat + "," + app.edicion_ubicacion_manual.lng
      } else {
        direccion_compuesta = ubicacion.direccion + ', ' + ubicacion.ciudad + ', ' + ubicacion.provincia
      }


      fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + direccion_compuesta + '&key=AIzaSyAO46ka6UUQlpdbobTcNvYa4mgTGAAgY5Q')
        .then(response => response.json())
        .then(function (data) {
          if (data.status == "OK") {
            nueva_ubicacion = ubicacion

            nueva_ubicacion.coordenadas = data.results[0].geometry.location
            nueva_ubicacion.place_id = data.results[0].place_id

            app.formCarga.ubicacion = nueva_ubicacion
            // $(".contenedor_mapa_ubicacion").slideUp(300)
            // $(".alerta_ubicacion_correcta").slideDown(300)



            contenedor_mapa_ubicacion = document.querySelector("#contenedor_mapa_ubicacion")

            var mapa_bs = new bootstrap.Collapse(contenedor_mapa_ubicacion,{
                toggle: false
              })
    
            mapa_bs.hide()


            alerta_ubicacion_correcta = document.querySelector("#alerta_ubicacion_correcta")

            alerta_correcta_bs = new bootstrap.Collapse(alerta_ubicacion_correcta,{
                toggle: false
              })

            alerta_correcta_bs.show()


            document.getElementById("validar_ubicacion_alert").value = "true"
            app.edicion_ubicacion_manual = {
              active: false,
              lat: 0,
              lng: 0
            }

          }
        });

    },

    ubicacionIncorrecta: function () {

      ubicacion = app.formCarga.ubicacion

      direccion_compuesta = ubicacion.direccion_1 + ', ' + ubicacion.ciudad + ' ' + ubicacion.cp + ', ' + ubicacion.provincia

      fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + direccion_compuesta + '&key=AIzaSyAO46ka6UUQlpdbobTcNvYa4mgTGAAgY5Q')
        .then(response => response.json())
        .then(function (data) {
          if (data.status == "OK") {

            coordenadas = data.results[0].geometry.location
            function initialize() {
              // Creating map object
              var map = new google.maps.Map(document.getElementById('map'), {
                zoom: 16,
                center: new google.maps.LatLng(coordenadas.lat, coordenadas.lng)
              });

              // creates a draggable marker to the given coords
              var vMarker = new google.maps.Marker({
                position: new google.maps.LatLng(coordenadas.lat, coordenadas.lng),
                draggable: true
              });

              // adds a listener to the marker
              // gets the coords when drag event ends
              // then updates the input with the new coords
              google.maps.event.addListener(vMarker, 'dragend', function (evt) {
                app.edicion_ubicacion_manual.active = true
                app.edicion_ubicacion_manual.lat = evt.latLng.lat()
                app.edicion_ubicacion_manual.lng = evt.latLng.lng()

                map.panTo(evt.latLng);
              });

              // centers the map on markers coords
              map.setCenter(vMarker.position);

              // adds the marker on the map
              vMarker.setMap(map);
            }
            initialize()
          }
        });



    },
    crearNombre: function (nombre_lugar) {
      return nombre_lugar.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll(" ", "-").toLowerCase() + "-" + Math.floor(Math.random() * 10000)
    },

    agregarLugar: function () {
        if (grecaptcha.getResponse() != '') {

        
      var objeto_nuevo_lugar = app.formCarga
      // objeto_nuevo_lugar.id_usuario = session_admin.id_usuario
      objeto_nuevo_lugar.id_usuario = "solicitud"

      objeto_nuevo_lugar.simple = app.crearNombre(objeto_nuevo_lugar.nombre)
      objeto_nuevo_lugar.timestamp = firebase.firestore.Timestamp.now()


          db.collection("solicitudes").add(objeto_nuevo_lugar)
            .then(function (docRef) {


              objeto_nuevo_lugar = {};

              formulario = document.querySelector("#contenedor_formulario")

              var form_bs = new bootstrap.Collapse(formulario,{
                toggle: false
              })
      
              form_bs.hide()


              enviado_correctamente = document.querySelector("#contenedor_enviado")

              var enviado_bs = new bootstrap.Collapse(enviado_correctamente,{
                toggle: false
              })
      
              enviado_bs.show()

              app.resetFormCarga()


            })
            .catch(function (error) {
              //Error Mesa
              console.log(error)

              mdtoast('Error al enviar la solicitud, volvé a cargar el sitio.', { duration: 15000, type: mdtoast.ERROR });
            });
          // app.pedidos_recibidos = app.pedidos_recibidos.concat(array_dia)

          // localStorage.removeItem('dia-' + fecha);
          // localStorage.setItem('dia-' + fecha, JSON.stringify(array_dia));

          // db.collection("lugares").doc(session_admin.id_lugar).collection("SHA1").doc(fecha).set({ SHA1_dia: CryptoJS.SHA1(JSON.stringify(array_dia)).toString() })

       
    } else {
        // Agregar alerta captcha necesario
    }


























    },
    agregarLugarError: function () {
      // mdtoast('Pedido cargado correctamente', { duration: 5000, type: mdtoast.SUCCESS });
      mdtoast('No se pudieron guardar los cambios.', { duration: 15000, type: mdtoast.ERROR });
    }
  },
  mounted: function () {

  }
})
